import { getMaps, getMapVisualization, GetMapFiltersData } from '@/api/maps'
const state = {
  selectedmap: {
    mapvisualizationobject: null,
    mapvisualizationval: 'satellite_view',
    typologieMap: null,
    map_data_name: null,
    maptitle_array: null,
    mapvisualizationtitle: null,
    mapvisualizationtitle_clean: null
  },
  selectedmapvisualization: null,
  token: '',
  availablemaps: [],
  mapfiltersconfig: null,
  mapfilters: [],
  mapview: null,
  mappoint: null
}

const mutations = {
  SET_MAPS: (state, maps) => {
    state.token = maps.maptoken
    state.availablemaps = maps.relations
  },
  SET_MAPVIEW: (state, view) => {
    state.mapview = view
  },
  SET_MAPPOINT: (state, point) => {
    state.mappoint = point
  },
  SET_SELECTED_MAP: (state, visualizationval) => {
    state.selectedmap = visualizationval
  },
  SET_FILTERS_MAP_CONFIG: (state, filters) => {
    state.mapfiltersconfig = filters
  },
  SET_FILTERS_MAP: (state, filters) => {
    state.mapfilters = filters
  },
  SET_SELECTED_VISUALIZATION: (state, visualization) => {
    if (visualization === null) {
      state.selectedmapvisualization = null
    } else {
      state.token = visualization.key
      state.selectedmapvisualization = visualization.data
    }
  }
}

const actions = {
  loadmaps({ commit }) {
    return new Promise((resolve, reject) => {
      getMaps().then((response) => {
        commit('SET_MAPS', response.data)
        resolve()
      }).catch((error) => {
        console.error(error)
        commit('SET_MAPS', [])
        reject()
      })
    })
  },
  setmapview({ commit }, mapview) {
    return new Promise((resolve, reject) => {
      commit('SET_MAPVIEW', mapview)
      resolve()
    })
  },
  setmappoint({ commit }, mappoint) {
    return new Promise((resolve, reject) => {
      commit('SET_MAPPOINT', mappoint)
      resolve()
    })
  },
  setselectedmap({ commit }, mapselected) {
    return new Promise((resolve, reject) => {
      if (mapselected.mapvisualizationval === 'satellite_view' || mapselected.mapvisualizationval === 'wms_view') {
        commit('SET_SELECTED_VISUALIZATION', null)
        commit('SET_SELECTED_MAP', mapselected)
        resolve()
      } else {
        getMapVisualization({ id: mapselected.mapvisualizationval }).then((response) => {
          commit('SET_SELECTED_VISUALIZATION', response.data)
          commit('SET_SELECTED_MAP', mapselected)
          resolve()
        }).catch((error) => {
          console.error(error)
          // commit('SET_SELECTED_MAP', nu)
          reject()
        })
      }
    })
  },
  setmapfilters({ commit }, filters) {
    return new Promise((resolve, reject) => {
      commit('SET_FILTERS_MAP', filters)
      resolve()
    })
  },
  GetMapFiltersData({ commit }, query) {
    return new Promise((resolve, reject) => {
      GetMapFiltersData(query).then((response) => {
        const filters = response.data
        commit('SET_FILTERS_MAP_CONFIG', filters)
        resolve(filters)
      }).catch((error) => {
        console.error(error)
        // commit('SET_SELECTED_MAP', nu)
        reject()
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
